<div class="wrapper">
  <div class="sidebar" data-color="white" data-active-color="danger">
    <app-sidebar></app-sidebar>
  </div>
  <div class="main-panel">
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>